<script>
// 加载中
import InnerLoading from '@/components/spinner/spinner.vue';
// 地图导航
// import MapNav from "@/components/technician/mapNav/map.vue";
import {branchInfoList2} from "@/lib/request";
import wx from "weixin-js-sdk";
export default {
  name:'techSiteId',
  data(){
    return{
      innerLoading:false,
      startPoint:{
        lng: null,
        lat: null
      },
      endPoint:{
        lng: null,
        lat: null
      },
      // 网点信息
      siteItem:{
        // siteId:'54010001',
        // businessType:'专营店',//经营类型
        // phone:'18810239821',//联系电话
        // area:'西藏自治区/拉萨市/城关区',//所在地区
        // info:'阳光道34号',
        // start:'9:00',//开始营业时间
        // end:'10:00'//结束营业时间
      },
      // 代销者信息
      userItem:{
        // name: '哈尼柯西',
        // phone: '18810239821',
        // email: '18810239821@163.com',
        // idCard: '110220198002012290',
        // backPhone: '010-002233',
      },
      staffList:[
        // {
        //   id:1,
        //   name:'李大海',
        //   phone:'18883002111',
        //   age:43,
        //   sex:'男',
        //   state:1,//1已通过，0待审核，2已删除，3已拒绝
        // }
      ],
    }
  },
  components:{
    // MapNav,
    InnerLoading
  },
  methods:{
    // 查询网点信息
    getSiteIdInfo(siteId){
      branchInfoList2({
        pageNum:1,
        pageSize:10,
        branchId:siteId
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              /*{
                  "branchId": 54010888,
                  "businessType": "1",
                  "businessStatus": 1,
                  "closureReason": "",
                  "agentInfo": {
                      "createDept": 103,
                      "createBy": 1,
                      "createTime": "2025-05-06 03:07:50",
                      "updateBy": 1,
                      "updateTime": "2025-06-04 14:10:29",
                      "userId": "1919469099591692290",
                      "city": "北京市",
                      "agentName": "程贺",
                      "gender": "2",
                      "contact": "17610836668",
                      "idCard": "231084198308160316",
                      "deptId": 103,
                      "bankName": "中国建设银行",
                      "bankBranch": "北京",
                      "bankCardNumber": "4367421144820151666",
                      "bankCommit": 1,
                      "branchInfo": null
                  },
                  "salespersonInfos": [
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-06 10:25:50",
                          "updateBy": null,
                          "updateTime": "2025-05-06 10:25:50",
                          "userId": "1919579324905238530",
                          "city": "西藏自治区/拉萨市",
                          "name": "陈雨欣",
                          "gender": "1",
                          "age": "33",
                          "contact": "15210826875",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 1
                      },
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-06 10:30:10",
                          "updateBy": null,
                          "updateTime": "2025-05-06 10:30:10",
                          "userId": "1919580416531574786",
                          "city": "西藏自治区/拉萨市",
                          "name": "姚洋",
                          "gender": "0",
                          "age": "32",
                          "contact": "18600921552",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 0
                      },
                      {
                          "createDept": 103,
                          "createBy": 1,
                          "createTime": "2025-05-16 22:50:56",
                          "updateBy": null,
                          "updateTime": "2025-05-16 22:50:56",
                          "userId": "1923390716042674177",
                          "city": "西藏自治区/拉萨市",
                          "name": "程销售",
                          "gender": "0",
                          "age": "43",
                          "contact": "13910888654",
                          "jobCertificate": null,
                          "registrationDate": null,
                          "deptId": 103,
                          "reviewStatus": 1
                      }
                  ],
                  "branchType": "2",
                  "branchLevel": "一级",
                  "province": "北京市",
                  "city": "北京市",
                  "district": "朝阳区",
                  "townShip": "太阳宫乡",
                  "address": "测试地址",
                  "storefrontPhoto": "1930145101589946369",
                  "storefrontPhotoUrl": "http://dcom.unlto.com/2025/06/04/14705e599c8a492e9b0bead10ff0cfb3.jpg",
                  "storefrontAddress": "北京市朝阳区太阳宫乡太阳宫体育休闲公园",
                  "updateTime": "2025-06-04 14:10:29",
                  "deptId": 103,
                  "companyName": null,
                  "taxpayerId": null,
                  "agentCertificate": "1927267299304898561",
                  "agentCertificateCode": null,
                  "agentCertificateUrl": "http://dcom.unlto.com/2025/05/27/87513a54b2684c9ebfd047eb6c674747.jpg",
                  "ticketPhoto": "1928374276233404417",
                  "ticketPhotoUrl": "http://dcom.unlto.com/2025/05/30/7f557941745e468896d324af0e694b17.jpg",
                  "registrationDate": null,
                  "longitude": 116.4484634399414,
                  "latitude": 39.98253631591797,
                  "storefrontCommit": 1,
                  "storefrontError": 1,
                  "registrationType": "1"
              }*/
              if(res.data.rows&&res.data.rows.length>0){
                this.siteItem = res.data.rows[0];
                this.userItem = res.data.rows[0].agentInfo;
                if(res.data.rows[0].latitude&&res.data.rows[0].longitude){
                  this.endPoint={
                    lat: res.data.rows[0].latitude,
                    lng: res.data.rows[0].longitude,
                  }
                }
                // this.staffList = res.data.rows[0].salespersonInfos;
                let arr = []
                res.data.rows[0].salespersonInfos.map((v)=>{
                  if(v.reviewStatus===1){
                    arr.push(v)
                  }
                });
                this.staffList = arr;
              }else{
                this.$toast(`暂无${siteId}网点数据，请检查网点是否正确！`);
              }
            }else{
              this.$toast.fail(res.data.msg);
            }
            this.innerLoading = false;
          }
        }
      });
    },
    getWechatLocation(){
      let that = this;
      // let url = window.location.href.split('#')[0];
      // if(url) {
      //   // 接口返回appid和签名类的数据
      //   this.$http.weChatScan_preScan({
      //     url:url,
      //   }).then((res) => {
      //     if (res&&res.data) {
      //       wx.config({
      //         debug: false, // 开启调试模式,
      //         appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
      //         timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      //         nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      //         signature: res.data.signature,// 必填，签名，见附录1
      //         jsApiList: [
      //           'checkJsApi',
      //           'openLocation',
      //           'getLocation',
      //           'openEnterpriseChat'
      //           // 'getLocation',
      //           // 'chooseImage',
      //           // 'scanQRCode',
      //           // 'getLocalImgData',
      //           // 'openCustomerServiceChat',
      //           // 'updateAppMessageShareData',
      //           // 'updateTimelineShareData', // 需要使用的JSAPI列表
      //           // 'onMenuShareTimeline', // 旧版朋友圈分享（兼容）
      //           // 'onMenuShareAppMessage' // 旧版好友分享（兼容）
      //         ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      //       });
      //       wx.ready(() => {
              wx.getLocation({
                type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入' gcj02 '
                success: function (data) {
                  console.log('getLocation地理位置',data)
                  if(data.latitude&&data.longitude){
                    that.startPoint = {
                      lat: data.latitude,
                      lng: data.longitude
                    }
                  }
                },
                fail: err => {
                  that.getConfig();
                  console.log(err);
                  console.log(err.errMsg);
                  if (err.errMsg.includes('user deny')) {
                    that.$toast = '您拒绝了位置授权，请前往设置开启';
                  } else {
                    that.$toast = `获取位置失败：${err.errMsg}`;
                  }
                }
              });
      //       });
      //       wx.error(error => {
      //         // this.$toast.fail('验证签名失败，无法获得微信分享功能')
      //         console.log('---wx.config---SDK初始化失败------');
      //         console.log(error)
      //         console.log(error.errMsg)
      //         // Dialog.alert({
      //         //   title: '获取地理位置失败',
      //         //   message: `
      //         //   <div class="innerDialog">
      //         //     <div style="text-align: left;">点击刷新按钮，再次操作上传门头照片功能，系统会给您授权地理位置的提示，请您务必选择允许按钮。</div>
      //         //   </div>`,
      //         //   confirmButtonText: '刷新',
      //         //   theme: 'round-button',
      //         // }).then(() => {
      //         //   // 刷新页面
      //         // location.reload();
      //         // });
      //       });
      //     }else{
      //       that.$toast('请求出错！')
      //     }
      //   });
      // }
    },
    getConfig(){
      let url = window.location.href.split('#')[0];
      if (url) {
        // 接口返回appid和签名类的数据
        this.$http.weChatScan_preScan({
          url: url,//encodeURIComponent(url),
        }).then((res) => {
          if (res) {
            if (res.code && res.code === 200) {
              wx.config({
                debug: false, // 开启调试模式,
                appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号cor pid
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                signature: res.data.signature,// 必填，签名，见附录1
                jsApiList: [
                  'checkJsApi',
                  'openLocation',
                  'getLocation',
                  'openEnterpriseChat'
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });
              wx.ready(() => {
                this.getWechatLocation();
              });
              wx.error(error => {
                console.error('---wx.config---SDK初始化失败------');
                console.error(error)
                console.error(error.errMsg)
              });
            }
          }
        });
      }
    },
    handleNavigation() {
      // 检查是否在微信环境中
      const isWeixin = /MicroMessenger/i.test(navigator.userAgent);
      if (isWeixin) {
        this.openInWeixin();
      } else {
        this.openInBrowser();
      }
    },
    openInWeixin() {
      // 微信环境下使用高德地图网页版
      const { lng: startLng, lat: startLat } = this.startPoint;
      const { lng: endLng, lat: endLat } = this.endPoint;
      if(startLng&&startLat){
        if(endLng&&endLat){
          // 微信中直接跳转
          window.location.href = `https://uri.amap.com/navigation?from=${startLng},${startLat}&to=${endLng},${endLat}&mode=car&src=yourAppName`;
        }else{
          this.$toast.fail('当前网点没有经纬度位置信息');
        }
      }else{
        this.$toast.fail('没有当前位置，请您允许微信获取您的当前位置')
      }

      // 或者使用微信JS-SDK的API（如果有）
      // if (typeof WeixinJSBridge !== "undefined") {
      //   WeixinJSBridge.invoke('jumpToBizWebview', {
      //     url: amapUrl
      //   });
      // } else {
      //   window.location.href = amapUrl;
      // }
    },
    openInBrowser() {
      // 非微信环境下的处理，可以尝试唤起高德地图APP
      const { lng: startLng, lat: startLat } = this.startPoint;
      const { lng: endLng, lat: endLat } = this.endPoint;

      // 尝试唤起APP的URL
      const amapAppUrl = `androidamap://navi?sourceApplication=yourAppName&poiname=目的地&lat=${endLat}&lon=${endLng}&dev=0&style=2`;

      // 设置一个定时器，如果APP没有启动则跳转网页版
      setTimeout(() => {
        window.location.href = `https://uri.amap.com/navigation?from=${startLng},${startLat}&to=${endLng},${endLat}&mode=car&src=yourAppName`;
      }, 2000);

      // 尝试唤起APP
      window.location.href = amapAppUrl;

      // 如果是iOS
      if (/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())) {
        window.location.href = `iosamap://navi?sourceApplication=yourAppName&poiname=目的地&lat=${endLat}&lon=${endLng}&dev=0&style=2`;
      }
    }
  },
  created(){
    let siteId = this.$route.query.siteId;
    if(siteId){
      this.innerLoading = true;
      // 查询网点信息
      this.getSiteIdInfo(siteId);
    }
    this.getWechatLocation();
  }
}
</script>
<template>
  <div class="content">
    <!--    加载中...-->
    <inner-loading v-model="innerLoading"></inner-loading>
    <div class="card" v-if="siteItem&&siteItem.branchId">
      <div class="card-title">网点资料</div>
      <div class="info-item">
        <div class="info-label">网点编号</div>
        <div class="info-value">{{siteItem.branchId}}</div>
      </div>
      <div class="info-item">
        <div class="info-label">所在地区</div>
        <div class="info-value">{{siteItem.city}}</div>
      </div>
      <div class="info-item">
        <div class="info-label">详细地址</div>
        <div class="info-value">{{siteItem.address}}</div>
      </div>
      <div class="info-item">
        <div class="info-label">销售员数量</div>
        <div class="info-value">{{staffList.length}}人</div>
      </div>
    </div>
    <div class="card" v-if="siteItem&&siteItem.branchId">
      <div class="card-title">代销者信息</div>
      <div class="info-item">
        <div class="info-label">姓名</div>
        <div class="info-value">{{ userItem.agentName }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">身份证号</div>
        <div class="info-value">{{ userItem.idCard|idCardHideValue }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">联系电话</div>
        <div class="info-value">{{ userItem.contact|phoneHideValue }}</div>
      </div>
      <div class="info-item" v-show="userItem.bankCardNumber">
        <div class="info-label">银行账户</div>
        <div class="info-value">{{ userItem.bankCardNumber|idCardHideValue }}</div>
      </div>
    </div>
    <div class="card" v-if="siteItem&&siteItem.branchId&&staffList.length>0">
      <div class="card-title">销售员信息</div>
      <div class="info-item" style="border-bottom: none; padding-bottom: 5px;">
        <div class="info-label" style="width: 100%;">已有销售员 ({{staffList.length}}人)</div>
      </div>
      <!-- 销售员 -->
      <div class="info-tff" v-for="(item,index) in staffList" :key="index" v-show="item.reviewStatus===1">
        <div class="info-item">
          <div class="info-label">姓名</div>
          <div class="info-value">{{ item.name }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">手机号</div>
          <div class="info-value">{{ item.contact|phoneHideValue }}</div>
        </div>
        <div class="info-item">
          <div class="info-label">性别</div>
          <div class="info-value">{{item.gender==='0'?'男':'女'}}</div>
        </div>
        <div class="info-item">
          <div class="info-label">年龄</div>
          <div class="info-value">{{item.age}}</div>
        </div>
      </div>
    </div>
    <van-button round block type="primary" color="#e62d2d" :disabled="!startPoint.lng" @click="handleNavigation">高德导航</van-button>
  </div>
</template>
<style scoped lang="scss">
.content{
  padding-top: 120px;
  box-sizing: border-box;
}
</style>